<button
  class="company-card-wrapper"
  (click)="openCompany()"
  [routerLink]="link$ | async"
>
  <div class="company-card-container">
    <div class="company-card-logo-wrapper" *ngIf="companyLogo">
      <img
        [src]="companyLogo"
        [alt]="company.name + ' Logo'"
        class="company-card-logo"
      />
    </div>

    <div class="flex flex-col space-y-2">
      <div class="company-name font-bold text-md">{{ company.name }}</div>
      <div *ngIf="formattedAddress()" class="company-address">
        <span>{{ formattedAddress() }}</span>
      </div>
      <div
        *ngIf="phoneNumber?.countryCode && phoneNumber?.phoneNumber"
        class="company-phone"
      >
        <span
          >{{ phoneNumber?.countryCode }} {{ phoneNumber?.phoneNumber }}</span
        >
      </div>

      <div class="company-card-info-mobile">
        <ng-template [ngTemplateOutlet]="companyInfo"></ng-template>
      </div>
    </div>
  </div>
  <div class="company-card-info">
    <ng-template [ngTemplateOutlet]="companyInfo"></ng-template>
  </div>
</button>

<ng-template #companyInfo>
  <div class="flex flex-col text-stone-500">
    <div class="flex items-center space-x-2">
      <!--      TODO update to use events aggregate-->
      <tix-icon svgIcon="calendar-solid"></tix-icon
      ><span>{{ company.upcomingEvents_aggregate.aggregate?.count ?? 0 }}</span>
      <span>{{
        company.upcomingEvents_aggregate.aggregate?.count ?? 0
          | i18nPlural: { '=1': 'Upcoming Event', other: 'Upcoming Events' }
      }}</span>
    </div>
    <div class="flex items-center space-x-2">
      <tix-icon svgIcon="location-marker-solid"></tix-icon
      ><span>{{ company.venues_aggregate?.aggregate?.count ?? 0 }}</span>
      <span>
        {{
          company.venues_aggregate?.aggregate?.count
            | i18nPlural: { '=1': 'Venue', other: 'Venues' }
        }}</span
      >
    </div>
    <div class="flex items-center space-x-2">
      <tix-icon svgIcon="users-solid"></tix-icon
      ><span>{{ company.contacts_aggregate?.aggregate?.count ?? 0 }}</span>
      <span>Staff</span>
    </div>
  </div>
</ng-template>
